export default class UiRoute {
  constructor(path, uiPage) {
    this.path = path;
    this.uiPage = uiPage;
    this.uiPage.setRoute(this);
  }
}
